import React from 'react';
import ObservationReviewPrint from './ObservationReviewPrint';

const ObservationReviewDetailedPrint = () => {
    return <ObservationReviewPrint isDetailed={true} />
}

export default ObservationReviewDetailedPrint;